import { ChannelPayloadFilter, ViewStream } from "spyne";
import { CodeGenViewstreamTraits } from "@franciscobatista/spyne-plugin-code-playground";
import { CodePlaygroundExamplesTraits } from "traits/code-playground-examples-traits";
import { CodePlaygroundExamplesIntroTraits } from "traits/code-playground-examples-intro-traits";
import { CodeContainerTraits } from "traits/code-container-traits";
import { CodePlaygroundExamplesDomTemplate } from "traits/code-playground-examples-dom-template";
import { CodePlaygroundExamplesDefine } from "traits/code-playground-examples-define";
import { CodePlaygroundExamplesAttributesTraits } from "traits/code-playground-examples-attributes-traits";
import { CodePlaygroundExamplesTemplatesTraits } from "traits/code-playground-examples-templates-traits";
import { CodePlaygroundExamplesTemplatesClaudeTraits } from "traits/code-playground-examples-templates-claude-traits";
import { CodePlaygroundExamplesWiringTraits } from "traits/code-playground-examples-wiring-traits";
import { CodePlaygroundExamplesAdaptTraits } from "traits/code-playground-examples-adapt-traits";

import { CodePlaygroundExamplesReferencesTraits } from "traits/code-playground-examples-references-traits";
import { CodePlaygroundExamplesReferencesViewstreamTraits } from 'traits/code-playground-examples-references-viewstream-traits';
import { CodePlaygroundExamplesDisposingTraits } from "traits/code-playground-examples-disposing-traits";
import { gsap } from "gsap";

const iframeSrc = "../../../../static/iframes/channel-3d-sync/index.html";

export class CodeContainerExamplesHolder extends ViewStream {
  constructor(props = {}) {
    props.tagName = props.data.addToMainDOM === true ? "div" : "iframe";
    props.id = "code-container-examples-holder";
    props.class = `code-container-examples ${props.data.codeBlockId} section-${props.data.codeBlockDataSection}`;
    props.traits = [
      CodeGenViewstreamTraits,
      CodePlaygroundExamplesTraits,
      CodePlaygroundExamplesIntroTraits,
      CodeContainerTraits,
      CodePlaygroundExamplesDomTemplate,
      CodePlaygroundExamplesDefine,
      CodePlaygroundExamplesAttributesTraits,
      CodePlaygroundExamplesTemplatesTraits,
      CodePlaygroundExamplesTemplatesClaudeTraits,
      CodePlaygroundExamplesWiringTraits,
      CodePlaygroundExamplesAdaptTraits,
      CodePlaygroundExamplesDisposingTraits,
      CodePlaygroundExamplesReferencesTraits,
      CodePlaygroundExamplesReferencesViewstreamTraits
    ];

    //console.log("PROPS FOR CONTAINER EXAMPLES ",props);
    if (props.tagName !== "iframe") {
      props.template = require("./templates/code-container-examples-holder.tmpl.html");
    }
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    const { parentVsid, codeBlockId } = this.props;
    const isContainerFilter = new ChannelPayloadFilter({
      payload: (v) => v.vsid === parentVsid,
    });

    const isCodeBlockIdFilter = new ChannelPayloadFilter({
      payload: (v) => v.codeBlockId === codeBlockId,
    });

    return [
      [
        "CHANNEL_CODE_CONTAINER_UPDATE_EVENT",
        "onChannelCodeContainerUpdateEvent",
        isCodeBlockIdFilter,
      ],
      ["CHANNEL_CODE_GEN_ANIM_COMPLETED", "onCodeHasAnimatedOld"],
    ];
  }


  onCodeHasAnimatedOld(){

  }
  onCodeHasAnimated(e, durationTime = 0.125) {
    //console.log("CODE HAS ANIMATED");
    try {
      const onRevealed = () => {
        try {
          this?.props?.el$?.addClass("revealed");
        } catch (e) {
         //console.log("item no longer exists ", e);
        }
      };
      gsap.to(this.props.example$, {
        opacity: 1,
        duration: durationTime,
        ease: "power1.inOut",
        onComplete: onRevealed,
      });
    } catch (e) {
     //console.log("el no longer exists ", this.props);
    }
  }

  onChannelCodeContainerUpdateEvent() {
    const onCompleteExample = () => this.disposeViewStream();
    this.props.el$.addClass("before-remove");
    gsap.to(this.props.example$, {
      opacity: 0,
      duration: 0.25,
      onComplete: onCompleteExample,
    });
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  checkToAddStyles() {
    const addIframeStyles = () => {
      let iframeDoc = this.props.el.contentDocument;
      let style = iframeDoc.createElement("style");
      style.type = "text/css";

      /*

          // colors.scss

// Tints (Lighter Variants for Inactive/Backgrounds)
$color-bg-very-light: #EFF6FB; // Very Light Background (Inactive)
$color-bg-light: #D2E4F3;      // Light Tint for low-emphasis elements
$color-bg-medium: #A5C9E5;     // Medium Tint for slightly noticeable elements

// Base Hue (Primary Blue)
$color-active: #4A90E2;        // Primary Active/Focus color

// Shades (Darker Variants for Hover/Selected States)
$color-hover: #357ABD;         // Hover/Focus State
$color-selected: #28588D;      // Selected/Pressed State


           */

      style.innerHTML = `
            body {
              font-family: system-ui, sans-serif;
              font-size: 18px;

            }
            
            
            p.code-sample {  

                font-size: 14px;
                font-family: monospace;
                color: #9AA5B1;
                


  
  
    white-space: pre-wrap;
  word-break: keep-all;
  overflow-wrap: break-word;
  font-family: monospace;
  
  
            }
            
            div{
              margin-bottom: .25rem;
            }


            
            li.box{
              width: 50px;
              height: 50px;
              background: olive;
              font-size: .5rem;
              padding: 8px;
              margin: 16px;
              list-style-type: none;
              margin: 16px 0;
            }
            
            li.green{
              background: #28588D;
            }
            
            li.blue{
              background: orange;
              color: darkblue;
            }
            
            li.box p{
              line-height: 110%;
              font-size: 12px;
              font-weight: 600;
              margin: 0;
              font-size: 15px;
            }
            
            li.red{
              background: #4A5E6C;
            }
            
            li.gray{
              background: #D2E4F3 ;
            }
            li.gray-dark{
               background: #4A5E6C;
            }
            
            li.orange{
              background: goldenrod;
            }
            
            li.purple{
              background: mediumorchid;
            }
            p {

            }
            
            ul{
              padding: 0;
              line-height: 130%;
            }
          `;
      iframeDoc.head.appendChild(style);
    };

    if (this.props.tagName === "iframe") {
      addIframeStyles();
    }
  }

  onRendered() {
    if (this.props.data.addToMainDOM !== true) {
      this.props.el.contentDocument.querySelector("html").style =
        "font-size:20px";
      this.props.example$ = this.props.el.contentDocument.body;
    } else {
      this.props.example$ = this.props.el;
    }
    this.props.example$.style.cssText = "overflow:hidden";
    gsap.set(this.props.example$, { opacity: 0 });

    if (this.props.iframeHeight !== undefined) {
      this.props.el.style.height = `${this.props.iframeHeight}px`;
    }
    //console.log('this props .holder ',this.props.el.contentWindow.document.body);
    // gsap.from(this.props.el, {opacity:0, delay:.5})

    const { methodSuffix } = this.props.data;
    //const methodName = `codeGen$Create${methodSuffix}`
    //const methodNameNew = `codePlaygroundExamples$${methodSuffix}`;
    const { methodName } = this.props.data;

    //const fn = ()=>console.log('method name is ',methodName);// this[methodName]
    const fn = this[methodName];

    const props = {
      tagName: "img",
      width: "250px",
      src: "https://holdrr.com/s/moon.jpg",
    };

    // const iframeBody = this.props.el.contentDocument.body;

    const delayer1 = () => {
      const div = this.props.el.contentDocument.createElement("div");
      div.setAttribute("id", "embed-sdk");
      this.props.el.contentDocument.body.appendChild(div);
      const iframeEl =
        this.props.el.contentDocument.body.querySelector("#embed-sdk");
      new ViewStream(props).appendToDom(iframeEl);

      //console.log("APPEND TO IFRAME ",iframeEl);
    };

    const delayer = () => {
      //console.log("DELAYER DEFINED ",this);
      if (this === undefined || this.props === undefined) {
        return;
      }

      //const scriptResult = fn(true);
      //   const scriptString = fn(true);

      const { scriptString, scriptContentArr } =
        this.codeContainer$ReturnScriptStringContent(fn);

      const { codeBlockId, parentVsid } = this.props;
      const { num, prevNum } = this.props.data;

      if (this.props !== undefined) {
        this.codeContainer$SendParseDataEvent({
          scriptString,
          scriptContentArr,
          parentVsid,
          codeBlockId,
          num,
          prevNum,
        });
      }

      if (this.props.data.initialLoad === true) {
        this.onCodeHasAnimated({}, 0.02);
        this.props.el$.addClass("revealed");
      }
    };

    //window.setTimeout(delayer, 60);
    let isFirefox = navigator.userAgent.includes("Firefox");

    const ffDelay = () => requestAnimationFrame(delayer);

    isFirefox === true ? window.setTimeout(ffDelay, 100) : ffDelay();
    // window.setTimeout(ffDelay, 60);

    //console.log("FN IS codeGen$CreateViewStreamInstance",this.props.el,methodName, {fn,methodSuffix, methodName});

    /*  const addAfterFrames=(method, n=1)=>{
        let count = 0;
        const checkToRun = ()=>{
         //console.log('check to run')
          if (count>=n){
            requestAnimationFrame(method)
          } else {
            count++;
            requestAnimationFrame(checkToRun);
          }


        }

        checkToRun();

      }
*/

    // fn(true);

    //const addEl = ()=>fn();

    //const addEl2 = ()=>requestAnimationFrame(addEl);
    //const addEl3 = ()=>requestAnimationFrame(addEl2);
    //requestAnimationFrame(addEl3);
    //window.setTimeout(addEl, 120);

    //addAfterFrames(fn,3);

    //console.log('menu suffix is ',methodSuffix);
    this.addChannel("CHANNEL_CODE_CONTAINER", true);

    this.addChannel("CHANNEL_CODE_GEN");

    window.setTimeout(this.onCodeHasAnimated.bind(this), 250);

    this.checkToAddStyles();
  }
}
